import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import { TextField, Button, Grid, Typography, CircularProgress, MenuItem, Checkbox } from '@material-ui/core'
import { authActions, studentActions } from '_state/actions'
import { ReactComponent as CapeeshLogo } from 'assets/images/capeesh_logo.svg'
import { FormattedMessage } from 'react-intl'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { makeStyles } from '@material-ui/core/styles'
import EmailValidator from 'email-validator'
import Footer from '../../Components/Footer'
import { studentAuthActions } from '../../_state/actions'
import { CapeeshColors } from '../../assets/ColorPalette'
import { CapeeshLanguage } from '../../Logic/CapeeshConstants'
import LocalizationSelector from '../../Components/LocalizationSelector/LocalizationSelector'

import { capeeshWebAppVersion } from '../../Components/AppWebGL/StudentCapeeshWeb/CapeeshWebView'

const useStyles = makeStyles((theme) => ({
    gridContainer: {
        padding: 30,
        backgroundColor: '#F8F8F8',
    },
    loginCard: {
        marginTop: '20px',
        marginBottom: '300px',
    },
    rightIcon: {
        marginLeft: theme.spacing(1),
    },
    margin: {
        margin: theme.spacing(1),
    },
    iconSmall: {
        fontSize: 20,
    },
    headerText: {
        padding: '10px 0px 10px 0px',
    },
    textFieldHeader: {
        marginLeft: '10px',
        textAlign: 'left',
    },
    forgotpassword: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px auto',
        cursor: 'pointer',
        '&:hover': {
            color: '#3273dc',
            textDecoration: 'underline',
        },
        fontSize: '16px',
    },
    loader: {
        margin: 'auto auto',
        display: 'block',
    },
    inputField: {
        marginTop: '7px',
        marginLeft: '10px',
        marginRight: '20px',
        width: '95%',
        variant: 'outlined',
        align: 'center',
    },
    capeeshLogo: {
        fill: CapeeshColors.Primary900,
        display: 'inherit',
        marginTop: '20px',
    },
    centerMidDiv: {
        display: 'flex',
        justifyContent: 'center',
    },
    termsRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '20px',
    },
    termsLabel: {
        fontFamily: 'Rubik',
        fontSize: '14px',
        color: CapeeshColors.DarkText,
    },
    termsLink: {
        color: CapeeshColors.Primary600,
        textDecoration: 'underline',
    },
    termsRequiredNotice: {
        fontFamily: 'Rubik',
        fontSize: '13px',
        color: '#C62828',
        textAlign: 'center',
        marginTop: '4px',
    },
    callToActionButton: {
        width: '300px',
        marginTop: '25px',
    },
    languageSelectorItem: {
        display: 'flex',
        alignItems: 'center',
    },
}))

export const LoginTabType = {
    Login: 1,
    Register: 0,
    LoginAccessCode: 2,
}
Object.freeze(LoginTabType)

const StudentLoginPage = (props) => {
    const classes = useStyles()

    const location = useLocation()

    const [email, setEmail] = useState('')
    const [accessCode, setAccessCode] = useState('')
    const [isValidEmail, setIsValidEmail] = useState(false)
    const [password, setPassword] = useState('')
    const [rememberMe, setRememberMe] = useState(true)
    const [activeTab, setActiveTab] = useState(LoginTabType.Login)
    const [allowUserNotifications, setAllowUserNotifications] = useState(false)

    const [showTooShortPasswordNotice, setShowTooShortPasswordNotice] = useState(false)
    const [showInvalidEmailNotice, setShowInvalidEmailNotice] = useState(false)

    // Privacy terms and conditions, never pre ticked
    const [termsAccepted, setTermsAccepted] = useState(false)
    const [showTermsRequiredNotice, setShowTermsRequiredNotice] = useState(false)

    const [studentLocalizationLanguages, setStudentLocalizationLanguages] = useState([])

    const setupLocalizationLanguages = () => {
        if (props.student.languages?.length > 0) {
            var filteredLanugages = props.student.languages.filter((x) => x.id !== CapeeshLanguage.Bengali)
            setStudentLocalizationLanguages(filteredLanugages)
        }
    }

    useEffect(() => {
        props.dispatch(studentAuthActions.studentLogout())
        props.dispatch(studentActions.getStudentLanguageMetadata())
        setupLocalizationLanguages()
        const params = new URLSearchParams(location.search)
        const emailFromParams = params.get('email')
        const register = params.get('register')
        const accessCode = params.get('accessCode')

        if (emailFromParams != null) {
            setEmail(emailFromParams)
            validateEmail(emailFromParams)
        }

        if (register === 'true') {
            setActiveTab(LoginTabType.Register)
        }

        if (location.pathname === 'student/register') {
            setActiveTab(LoginTabType.Register)
        }
        if (accessCode) {
            setActiveTab(LoginTabType.LoginAccessCode)
            setAccessCode(accessCode.toUpperCase())
        }
    }, [])

    useEffect(() => {
        if (props.student.languages) {
            setupLocalizationLanguages()
        }
    }, [props.student])

    const handleChangeTab = (event, value) => {
        if (value === LoginTabType.Login || value === LoginTabType.Register || value === LoginTabType.LoginAccessCode) {
            setActiveTab(value)
        }
    }
    const handleChangePassword = (e) => {
        setPassword(e.target.value)
        if (showTooShortPasswordNotice) {
            setShowTooShortPasswordNotice(false)
        }
    }
    const handleChangeEmail = (e) => {
        setEmail(e.target.value)
        setShowInvalidEmailNotice(false)

        validateEmail(email)
    }

    const handleChangeAccessCode = (e) => {
        setAccessCode(e.target.value.toUpperCase())
    }

    const validateEmail = (currentEmail) => {
        let emailValidates = EmailValidator.validate(currentEmail)
        setIsValidEmail(emailValidates)
        if (emailValidates) {
            setShowInvalidEmailNotice(false)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        // if autofilled by chrome or password keepers
        let elements = e.target.elements
        let fieldEmail = elements?.length > 0 ? elements[0].value : ''
        let fieldPassword = elements?.length > 2 ? elements[2].value : ''

        // keep a local state of the email and validation to overwrite in the case the fields have been filled in
        let submitEmail = email.trim()
        let submitPassword = password.trim()
        let submitIsValidEmail = isValidEmail

        if (!submitEmail && fieldEmail) {
            submitEmail = fieldEmail
        }

        if (EmailValidator.validate(submitEmail)) {
            submitIsValidEmail = true
        }

        if (!submitPassword && fieldPassword) {
            submitPassword = fieldPassword
        }

        if (submitEmail && submitPassword && submitIsValidEmail && submitPassword.length >= 7) {
            if (activeTab === LoginTabType.Login) {
                props.dispatch(
                    studentAuthActions.studentLogin(
                        submitEmail,
                        submitPassword,
                        props.student.userDashboardLanguageId,
                        capeeshWebAppVersion
                    )
                )
            }
            if (activeTab === LoginTabType.Register) {
                if (!termsAccepted) {
                    setShowTermsRequiredNotice(true)
                    return
                }

                props.dispatch(
                    studentAuthActions.studentRegister(
                        submitEmail,
                        submitPassword,
                        true,
                        props.student.userDashboardLanguageId,
                        capeeshWebAppVersion,
                        termsAccepted
                    )
                )
            }
        }
        if (submitPassword && submitPassword.length < 7) {
            setShowTooShortPasswordNotice(true)
        }
        if (submitEmail && !submitIsValidEmail) {
            setShowInvalidEmailNotice(true)
        }
    }

    const handleSignInWithAccessCode = () => {
        props.dispatch(
            studentAuthActions.studentLoginWithAccessCode(
                accessCode,
                props.student.userDashboardLanguageId,
                capeeshWebAppVersion
            )
        )
    }

    const changeLocalizedLanguage = (e) => {
        props.dispatch(studentActions.setStudentDashboardLanguage(e.target.value))
    }

    return (
        <div>
            <Grid container alignItems="center" justify="center" className={classes.gridContainer}>
                <Grid item xs={12} sm={10} md={5}>
                    <Card className={classes.loginCard} style={{ borderRadius: '20px' }}>
                        <Grid item xs={12}>
                            <Grid
                                container
                                style={{
                                    backgroundColor: CapeeshColors.Primary900,
                                }}>
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}>
                                    <div
                                        style={{
                                            width: '180px',
                                            backgroundColor: 'white',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            marginRight: '20px',
                                            borderRadius: '5px',
                                            marginLeft: 'auto',
                                        }}>
                                        <LocalizationSelector
                                            localizationLanguages={studentLocalizationLanguages}
                                            onChangeLocalizedLanguage={changeLocalizedLanguage}
                                            dashboardLanguageId={props.student?.userDashboardLanguageId}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.centerMidDiv}>
                                <CapeeshLogo width={550} height={150} className={classes.capeeshLogo} />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h6" align="center">
                                <FormattedMessage
                                    id="student.loginpage.title"
                                    defaultMessage="Capeesh Student portal"
                                />
                            </Typography>
                        </Grid>
                        <Tabs
                            value={activeTab}
                            onChange={handleChangeTab}
                            indicatorColor="primary"
                            textColor="primary"
                            style={{
                                marginTop: '40px',
                            }}
                            centered>
                            <Tab
                                value={LoginTabType.Register}
                                label={<FormattedMessage id="student.loginpage.register" defaultMessage="Register" />}
                                className={activeTab === LoginTabType.Register ? 'active' : ''}
                            />
                            <Tab
                                value={LoginTabType.Login}
                                label={<FormattedMessage id="student.loginpage.signin" defaultMessage="Sign in" />}
                                className={activeTab === LoginTabType.Login ? 'active' : ''}
                            />
                            <Tab
                                value={LoginTabType.LoginAccessCode}
                                label={
                                    <FormattedMessage id="student.loginpage.access code" defaultMessage="Access code" />
                                }
                                className={activeTab === LoginTabType.LoginAccessCode ? 'active' : ''}
                            />
                        </Tabs>

                        <CardContent>
                            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Grid item xs={12}>
                                            <Typography
                                                variant="body1"
                                                align="center"
                                                className={classes.textFieldHeader}>
                                                {activeTab === LoginTabType.LoginAccessCode ? (
                                                    <FormattedMessage
                                                        id="student.loginpage.accessCode.colon"
                                                        defaultMessage="Access code:"
                                                    />
                                                ) : (
                                                    <FormattedMessage
                                                        id="student.loginpage.email.colon"
                                                        defaultMessage="Email:"
                                                    />
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {activeTab === LoginTabType.LoginAccessCode ? (
                                                <TextField
                                                    id="username"
                                                    variant="outlined"
                                                    value={accessCode}
                                                    onChange={handleChangeAccessCode}
                                                    fullWidth
                                                    className={classes.inputField}
                                                    inputProps={{ style: { textAlign: 'center' } }}
                                                />
                                            ) : (
                                                <TextField
                                                    id="username"
                                                    variant="outlined"
                                                    value={email}
                                                    onChange={handleChangeEmail}
                                                    fullWidth
                                                    error={showInvalidEmailNotice}
                                                    className={classes.inputField}
                                                />
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            {showInvalidEmailNotice && (
                                                <Typography
                                                    variant="body1"
                                                    align="center"
                                                    style={{
                                                        marginTop: '10px',
                                                    }}
                                                    className={classes.textFieldHeader}>
                                                    <FormattedMessage
                                                        id="student.loginpage.notvalidemailmsg"
                                                        defaultMessage="Not valid email"
                                                    />
                                                </Typography>
                                            )}
                                        </Grid>

                                        <Grid item xs={12}>
                                            {activeTab === LoginTabType.Register && (
                                                <Typography
                                                    variant="body1"
                                                    align="center"
                                                    style={{
                                                        marginTop: '25px',
                                                    }}
                                                    className={classes.textFieldHeader}>
                                                    <FormattedMessage
                                                        id="student.loginpage.createnewpassword"
                                                        defaultMessage="Create new password:"
                                                    />
                                                </Typography>
                                            )}
                                            {activeTab === LoginTabType.Login && (
                                                <Typography
                                                    variant="body1"
                                                    align="center"
                                                    style={{
                                                        marginTop: '25px',
                                                    }}
                                                    className={classes.textFieldHeader}>
                                                    <FormattedMessage
                                                        id="student.loginpage.password"
                                                        defaultMessage="Password:"
                                                    />
                                                </Typography>
                                            )}
                                        </Grid>
                                        {activeTab !== LoginTabType.LoginAccessCode && (
                                            <Grid item xs={12}>
                                                <TextField
                                                    name="password"
                                                    id="password"
                                                    variant="outlined"
                                                    label={
                                                        activeTab === LoginTabType.Login ? (
                                                            <FormattedMessage
                                                                id="globalwords.password"
                                                                defaultMessage="Password"
                                                            />
                                                        ) : (
                                                            'Create new password'
                                                        )
                                                    }
                                                    type="password"
                                                    value={password}
                                                    onChange={handleChangePassword}
                                                    fullWidth
                                                    error={showTooShortPasswordNotice}
                                                    className={classes.inputField}
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12}>
                                            {showTooShortPasswordNotice && (
                                                <Typography
                                                    variant="body1"
                                                    align="center"
                                                    style={{
                                                        marginTop: '10px',
                                                    }}
                                                    className={classes.textFieldHeader}>
                                                    <FormattedMessage
                                                        id="student.loginpage.passwordtoshortmsg"
                                                        defaultMessage="Password too short"
                                                    />
                                                </Typography>
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            {activeTab === LoginTabType.Login && (
                                                <Typography
                                                    variant="body1"
                                                    align="center"
                                                    style={{
                                                        marginTop: '25px',
                                                    }}
                                                    className={classes.textFieldHeader}>
                                                    <b>NB!</b>{' '}
                                                    <FormattedMessage
                                                        id="student.loginpage.passwordintheappthesame"
                                                        defaultMessage="Your password here is the same as in the Capeesh App"></FormattedMessage>
                                                </Typography>
                                            )}
                                            {activeTab === LoginTabType.Register && (
                                                <Typography
                                                    variant="body1"
                                                    align="center"
                                                    style={{
                                                        marginTop: '25px',
                                                    }}
                                                    className={classes.textFieldHeader}>
                                                    <FormattedMessage
                                                        id="student.loginpage.tooshortpasswordmsg"
                                                        defaultMessage="Your password needs to be at least 7 letters."
                                                    />
                                                </Typography>
                                            )}
                                        </Grid>
                                    </Grid>
                                    {activeTab === LoginTabType.Register && (
                                        <Grid item xs={12}>
                                            <div className={classes.termsRow}>
                                                <Checkbox
                                                    checked={termsAccepted}
                                                    onChange={(event) => {
                                                        setTermsAccepted(event.target.checked)
                                                        if (event.target.checked) {
                                                            setShowTermsRequiredNotice(false)
                                                        }
                                                    }}
                                                    color="primary"
                                                    size="small"
                                                    inputProps={{ 'aria-label': 'accept privacy terms and conditions' }}
                                                />
                                                <Typography className={classes.termsLabel}>
                                                    <FormattedMessage
                                                        id="student.screen.terms.accept.label"
                                                        defaultMessage="I accept the"
                                                    />{' '}
                                                    <a
                                                        href="https://www.capeesh.com/about-us/privacy/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className={classes.termsLink}>
                                                        <FormattedMessage
                                                            id="student.screen.terms.accept.link.text"
                                                            defaultMessage="privacy terms and conditions"
                                                        />
                                                    </a>
                                                </Typography>
                                            </div>
                                            {showTermsRequiredNotice && (
                                                <Typography className={classes.termsRequiredNotice}>
                                                    <FormattedMessage
                                                        id="student.screen.terms.required.hint"
                                                        defaultMessage="Please accept the privacy terms and conditions to continue"
                                                    />
                                                </Typography>
                                            )}
                                        </Grid>
                                    )}
                                    <Grid item xs={12}>
                                        {props.studentAuth?.registering || props.studentAuth?.loggingIn ? (
                                            <CircularProgress className={classes.loader} size={30} />
                                        ) : (
                                            <div className={classes.centerMidDiv}>
                                                {activeTab === LoginTabType.LoginAccessCode ? (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleSignInWithAccessCode}
                                                        className={classes.callToActionButton}
                                                        disabled={!accessCode}>
                                                        <FormattedMessage
                                                            id="globalwords.sign_in.with.access.code"
                                                            defaultMessage="Sign in with access code"
                                                        />
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        className={classes.callToActionButton}
                                                        disabled={!email || !password}>
                                                        {activeTab === LoginTabType.Login && (
                                                            <FormattedMessage
                                                                id="globalwords.sign_in"
                                                                defaultMessage="Sign in"
                                                            />
                                                        )}
                                                        {activeTab === LoginTabType.Register && (
                                                            <FormattedMessage
                                                                id="student.login.activateUser"
                                                                defaultMessage="Activate user"
                                                            />
                                                        )}
                                                    </Button>
                                                )}
                                            </div>
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {activeTab === LoginTabType.Login && (
                                            <Typography
                                                variant="caption"
                                                align="center"
                                                className={classes.forgotpassword}
                                                component={Link}
                                                to="/student/forgot">
                                                <FormattedMessage
                                                    id="student.loginpage.forgottenpasswordlink"
                                                    defaultMessage="Forgotten password?"
                                                />
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Footer />
        </div>
    )
}

StudentLoginPage.propTypes = {}

const mapToProps = (state) => {
    return {
        studentAuth: state.studentAuth,
        student: state.student,
    }
}

const mapDispatchToProps = (dispatch) => {
    return { dispatch: dispatch }
}
export default connect(mapToProps, mapDispatchToProps)(StudentLoginPage)
